const apiUrl = import.meta.env.VITE_CP_API_URL as string | undefined

if (!apiUrl) {
  throw new Error('VITE_CP_API_URL is not set. Copy .env.example to .env.local.')
}

export const env = {
  /** e.g. http://localhost:8000/cp/v1 */
  apiUrl: apiUrl.replace(/\/$/, ''),
  /** The CSRF cookie's name: staging's differs from production's (CP-XSRF-TOKEN on .arvaseo.com). */
  xsrfCookie: (import.meta.env.VITE_CP_XSRF_COOKIE as string | undefined) || 'CP-XSRF-TOKEN',
  /** e.g. https://api.arvaseo.com: Horizon (queues) is served there. */
  apiOrigin: new URL(apiUrl).origin,
} as const
